import { FormattedRunTypeMap } from "../../../../../types";

export const formattedRunTypeMap: FormattedRunTypeMap = {
  melt: "Melt Run",
  isothermal: "Isothermal Run",
  qualitative: "Qualitative Run",
  quantitative: "Quantitative Run",
};
